const formatter = new Intl.RelativeTimeFormat('fr', { numeric: 'auto' })

export function formatRelativeTime(isoString: string): string {
  const diffMs = new Date(isoString).getTime() - Date.now()
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24))
  if (Math.abs(diffDays) >= 1) return formatter.format(diffDays, 'day')

  const diffHours = Math.round(diffMs / (1000 * 60 * 60))
  if (Math.abs(diffHours) >= 1) return formatter.format(diffHours, 'hour')

  const diffMinutes = Math.round(diffMs / (1000 * 60))
  return formatter.format(diffMinutes, 'minute')
}
